import React, { useState } from "react";
import "./EventPage.css";
import { Link } from "react-router-dom";

const accordionData = [
  {
    title: "What types of events can be hosted?",
    content: "We offer venues for weddings, corporate events, family reunions, birthday parties, anniversary celebrations, product launches, conferences, and social gatherings. Our versatile spaces can be customized to match any event theme or requirement.",
  },
  {
    title: "What is the maximum guest capacity?",
    content: "We can host events for up to 3000 guests, depending on the venue type. Our intimate indoor spaces accommodate 20-200 guests, while our grand outdoor venues can host 500-3000 guests comfortably.",
  },
  {
    title: "Do you provide catering services?",
    content: "Yes, we offer both in-house and customizable catering packages. Our expert chefs can prepare multi-cuisine menus including Indian, Continental, Chinese, and fusion dishes. We also accommodate dietary restrictions and special requests.",
  },
  {
    title: "What amenities are included?",
    content: "Our venues come with modern amenities including air conditioning, sound systems, lighting equipment, projectors, WiFi, parking facilities, security, and dedicated event coordinators to ensure your event runs smoothly.",
  },
  {
    title: "Can we customize the décor?",
    content: "Absolutely! We offer full décor customization services with our in-house design team. From floral arrangements to themed decorations, lighting setups, and stage designs, we can transform any space to match your vision.",
  },
  {
    title: "What are your booking terms?",
    content: "We require a 30% advance payment to confirm your booking. The remaining balance can be paid in installments. We offer flexible cancellation policies and provide detailed contracts outlining all terms and conditions.",
  },
];

const features = [
  {
    icon: "🏛️",
    title: "Room Service",
    description: "Sangam Resort & banquet provides exclusively designed deluxe/luxury rooms."
  },
  {
    icon: "🎪",
    title: "Custom Décor",
    description: "Personalized decoration services to match your event theme"
  },
  {
    icon: "🍽️",
    title: "Premium Catering",
    description: "Multi-cuisine options with expert culinary teams"
  },
  {
    icon: "🎵",
    title: "Audio-Visual",
    description: "State-of-the-art sound and lighting equipment"
  },
  {
    icon: "🚗",
    title: "Valet Parking",
    description: "Complimentary parking with valet services"
  },
  {
    icon: "🛡️",
    title: "24/7 Security",
    description: "Round-the-clock security for your peace of mind"
  },
];

const testimonials = [
  {
    name: "Priya & Rajesh",
    event: "Wedding Celebration",
    text: "Our dream wedding became a reality here! The team exceeded our expectations with stunning décor and flawless execution.",
    rating: 5
  },
  {
    name: "Tech Solutions Ltd.",
    event: "Corporate Annual Meet",
    text: "Perfect venue for our 500+ employee gathering. Professional service and excellent facilities made our event memorable.",
    rating: 5
  },
  {
    name: "Sharma Family",
    event: "Golden Anniversary",
    text: "Celebrated our parents' 50th anniversary here. The intimate setting and personalized service made it truly special.",
    rating: 5
  },
];

const EventPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const renderStars = (rating) => {
    return "⭐".repeat(rating);
  };

  return (
    <div className="event-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content-event">
          <h1>Transform Your Special Moments</h1>
          <p className="hero-subtitle">Create unforgettable memories in our premium event venues</p>
          {/* <button className="cta-button">Explore Venues</button> */}
        </div>
        <div className="hero-overlay"></div>
      </div>

      {/* Main Content */}
      <div className="event-content">
        <div className="event-image">
          <img src="/image2.jpg" alt="Elegant Event Hall" />
          <div className="image-badge">
            <span>Premium Venue</span>
          </div>
        </div>
        <div className="event-details">
          <div className="event-tags">
            <span className="tag">Wedding Venues</span>
            <span className="tag">Reception</span>
            <span className="tag">Birthday Events</span>
            <span className="tag">Engagement Ceremony</span>
          </div>
          <h2>Luxury Event Venues in Bihar</h2>
          <p>
          Explore an exceptional selection of 15 indoor and outdoor venues at Sangam Resort & Banquet, thoughtfully designed to host events of all sizes. Whether you're planning an intimate gathering or a grand celebration, we offer versatile spaces tailored to your unique needs.
          </p>
          <p>
          Our venues accommodate everything from private functions with 20 guests to large-scale events hosting up to 3,000 attendees. Ideal for weddings, receptions, engagements, corporate retreats, family reunions, and social events, Sangam Resort & Banquet is your premier destination for memorable celebrations in Bihar.


          </p>
          
          <div className="venue-stats">
            {/* <div className="stat-item">
              <span className="stat-number">15+</span>
              <span className="stat-label">Venues</span>
            </div> */}
            <div className="stat-item">
              <span className="stat-number">500</span>
              <span className="stat-label">Max Capacity</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100+</span>
              <span className="stat-label">Events Hosted</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support</span>
            </div>
          </div>

          <div className="capacity-info">
            <span className="capacity-icon">👥</span>
            <span><strong>Capacity:</strong> 20 - 3000 guests</span>
          </div>
          
          <div className="action-buttons">
            <Link className="enquire-btn primary" to='/contact'>ENQUIRE NOW</Link>
            {/* <button className="enquire-btn secondary">VIRTUAL TOUR</button> */}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section">
        <h2>Why Choose Our Venues?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="testimonials-section">
        <h2>What Our Clients Say</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-rating">
                {renderStars(testimonial.rating)}
              </div>
              <p>"{testimonial.text}"</p>
              <div className="testimonial-author">
                <strong>{testimonial.name}</strong>
                <span>{testimonial.event}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ Section */}
      <div className="accordion-section">
        <h2>Frequently Asked Questions</h2>
        <div className="accordion-container">
          {accordionData.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-title"
                onClick={() => toggleAccordion(index)}
              >
                <h3>{item.title}</h3>
                <span className={`accordion-icon ${activeIndex === index ? 'active' : ''}`}>
                  {activeIndex === index ? "−" : "+"}
                </span>
              </div>
              {activeIndex === index && (
                <div className="accordion-content">
                  <p>{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Contact Section */}
      <div className="contact-section">
        <div className="contact-content">
          <h2>Ready to Plan Your Event?</h2>
          <p>Get in touch with our event specialists for a personalized consultation</p>
          <div className="contact-info">
            <div className="contact-item">
              <span>📞</span>
              <span>+91 8340539463</span>
            </div>
            <div className="contact-item">
              <span>✉️</span>
              <span>sangamluxurious@gmail.com</span>
            </div>
            <div className="contact-item">
              <span>📍</span>
              <span>NH-2 , Near Ashok Leyland,Ajrakwe Hasauli,Aurangabaad,Bihar 824101,India</span>
            </div>
          </div>
          <button className="contact-btn">SCHEDULE VISIT</button>
        </div>
      </div>
    </div>
  );
};

export default EventPage;